import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAIProposalAcceptButton = defineStore(
  'AIProposalAcceptButton',
  () => {
    const isAcceptClicked = ref(false)

    function triggerProposalAcceptance(): void {
      isAcceptClicked.value = true
    }

    return {
      isAcceptClicked,
      triggerProposalAcceptance,
    }
  }
)
